// @flow
import clsx from 'clsx';

import { Check } from 'lucide-react';

import { useTranslator } from '@gandi/translate';

import styles from './PlanContent.scss';

type Props = {
  cta?: React.Node,
  detail?: React.Node,
  options: Array<void | string>,
  price?: string,
  sizeLabel: string,
};

export function PlanContent({
  cta,
  detail,
  options,
  price,
  sizeLabel,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <>
      <div className={styles.titleContainer}>
        <span>{sizeLabel}</span>
        {price && (
          <div className={styles.priceContainer}>
            <div>
              <span className={styles.price}>{price}</span>/
              {__(
                '<for-translators-use>Periodicity (month)</for-translators-use>mo',
              )}
            </div>
            {detail ? <div className={styles.detail}>{detail}</div> : null}
          </div>
        )}
      </div>
      <ul className={styles.options}>
        {options.map(
          option =>
            option && (
              <li key={option}>
                <Check size={16} />
                <span>{option}</span>
              </li>
            ),
        )}
      </ul>
      {cta}
    </>
  );
}

type PropsPlanDisplay = {
  ...Props,
  disabled?: boolean,
  isSelected?: boolean,
};

// To use without form
export const PlanDisplay = ({
  cta,
  isSelected,
  sizeLabel,
  price,
  detail,
  options,
  disabled,
}: PropsPlanDisplay): React.MixedElement => (
  <div
    className={clsx(
      styles.root,
      disabled ? styles.disabled : undefined,
      isSelected ? styles.isSelected : undefined,
    )}
  >
    <PlanContent
      sizeLabel={sizeLabel}
      price={price}
      detail={detail}
      options={options}
      cta={cta}
    />
  </div>
);
